import { Image } from './image.model';

export class Employee {
  
  public id: string;
  public itemId: string;
  public name: string;
  public slug: string;
  public shortName: string;
  public shortDescription: string;
  public shortDescriptionTranslations: Object;
  public longDescription: string;
  public longDescriptionTranslations: Object;
  public title: string;
  public avatar: Image;
  public availableForBooking: boolean;
  public public: boolean;
  public onSchedule: boolean;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id && obj.id.toString() || null;

    this.itemId = obj && ( obj.itemId && obj.itemId.toString() || ( obj.item && obj.item.id && obj.item.id.toString()) ) || null;
    this.name = obj && ( obj.name || ( obj.item && obj.item.name) ) || null;
    this.slug = obj && ( obj.slug || ( obj.item && obj.item.slug) ) || null;
    this.shortName = obj && ( obj.shortName || ( obj.item && obj.item.shortName) ) || null;
    this.shortDescription = obj && ( obj.shortDescription || ( obj.item && obj.item.shortDescription ) ) || null;
    this.shortDescriptionTranslations = obj && ( obj.shortDescriptionTranslations || ( obj.item && obj.item.shortDescriptionTranslations ) ) || null;
    this.longDescription = obj && ( obj.longDescription || ( obj.item && obj.item.longDescription ) ) || null;
    this.longDescriptionTranslations = obj && ( obj.longDescriptionshortTranslations || ( obj.item && obj.item.longDescriptionTranslations ) ) || null;

    if ( obj && obj.avatar ) {
      this.avatar = ( obj.avatar instanceof Image ) ? obj.avatar: new Image( obj.avatar );
    }

    //this.avatar = obj && ( (obj.avatar && obj.avatar.document && obj.avatar.document.fileName ) || ( obj.item && obj.item.avatar && obj.item.avatar.document && obj.item.avatar.document.fileName ) ) || null;
    this.title = obj.title || null;

  }
  
}